import React from 'react';
import { Helmet } from 'react-helmet-async';
export const BusinessSchema: React.FC = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HVACBusiness',
    name: 'AIR-MAZING AIR, INC.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1JGevbSoLh1AeBrRR9hz3Q/IMG_1783.jpg',
    url: 'https://airmazingair.com',
    telephone: '+12398886268',
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Cape Coral',
      addressRegion: 'FL',
      postalCode: '33990',
      addressCountry: 'US',
      streetAddress: 'Cape Coral'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 26.5629,
      longitude: -81.9495
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59'
    },
    sameAs: ['https://www.facebook.com/airmazingairhvac', 'https://www.thumbtack.com', 'https://www.nextdoor.com'],
    description: 'Professional HVAC services including AC installation, repair, and maintenance in Southwest Florida. Available 24/7 for emergency service. We service Cape Coral, Fort Myers, Punta Gorda, and surrounding areas.',
    keywords: 'HVAC, air conditioning, AC repair, AC installation, duct cleaning, air quality, Cape Coral, Fort Myers, Southwest Florida, emergency AC repair, 24/7 HVAC service',
    areaServed: [{
      '@type': 'City',
      name: 'Cape Coral'
    }, {
      '@type': 'City',
      name: 'Fort Myers'
    }, {
      '@type': 'City',
      name: 'Punta Gorda'
    }, {
      '@type': 'City',
      name: 'Bonita Springs'
    }, {
      '@type': 'City',
      name: 'Naples'
    }, {
      '@type': 'City',
      name: 'Lehigh Acres'
    }],
    serviceArea: {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: 26.5629,
        longitude: -81.9495
      },
      geoRadius: '50000'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'HVAC Services',
      itemListElement: [{
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'AC Installation',
          description: 'High-efficiency 20 SEER and SEER 2 air conditioning system installation'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Emergency AC Repair',
          description: '24/7 emergency repair services for all makes and models'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Air Quality & Duct Cleaning',
          description: 'Comprehensive air quality solutions and professional duct cleaning'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Home Insulation',
          description: 'Energy-efficient insulation services for homes'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Commercial HVAC',
          description: 'Commercial HVAC solutions for businesses of all sizes'
        }
      }]
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '127'
    },
    review: [{
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'John Smith'
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5'
      },
      datePublished: '2023-08-15',
      reviewBody: 'Excellent service! The technician arrived promptly and fixed our AC during the hottest day of summer.'
    }, {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Maria Rodriguez'
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5'
      },
      datePublished: '2023-09-22',
      reviewBody: 'Very professional installation team. They completed our new AC system installation quickly and left everything clean.'
    }]
  };
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'AIR-MAZING AIR, INC.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1JGevbSoLh1AeBrRR9hz3Q/IMG_1783.jpg',
    url: 'https://airmazingair.com',
    telephone: '+12398886268',
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Cape Coral',
      addressRegion: 'FL',
      postalCode: '33990',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 26.5629,
      longitude: -81.9495
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59'
    }
  };
  return <Helmet data-id="element-89">
      <script type="application/ld+json" data-id="element-90">{JSON.stringify(schema)}</script>
      <script type="application/ld+json" data-id="element-91">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>;
};